import styled from '@emotion/styled'
import { useSessionContext } from 'contexts/session'
import { useNavigate } from 'react-router'
import { LOGIN_PATH } from 'routes/constants'
import Spacings from '../figma/tokens/Spacings'
import TextKeys from '../libs/TextKeys'
import FigmaBox from '../mynt-components/components/FigmaBox'
import { UnstyledButton } from '../mynt-components/components/StyledComponents'
import TextContainer from './TextContainer'

interface Props {
  isMobileHeader?: boolean
}

const HeaderButtonLogout: React.FC<Props> = ({ isMobileHeader = false }) => {
  const navigate = useNavigate()
  const { remoteSignout } = useSessionContext()
  const signout = remoteSignout?.()

  const handleSignOut = async () => {
    await signout?.()
    navigate(LOGIN_PATH)
  }

  return (
    <FigmaBox fullWidth={isMobileHeader} direction="row" align="center" justify={'space-between'} gap={Spacings.min}>
      <StyledButton tabIndex={-1} onClick={handleSignOut}>
        <TextContainer textKey={TextKeys.headerSignOut} />
      </StyledButton>
    </FigmaBox>
  )
}

const StyledButton = styled(UnstyledButton)`
  white-space: nowrap;
`

export default HeaderButtonLogout
